import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {MonedasComponent} from '../monedas.component'
//Services
import {CurrencyService} from 'src/app/core/services/parameters/currency.service';
//Alert
import {AlertNoticeService} from 'src/app/core/alert/alert.service';

@Component({
  selector: 'create-modal',
  templateUrl: './create-modal.html',
  styleUrls: ['./create-modal.component.scss']
})
export class CrearMonedaModal implements OnInit {

  newCurrencyForm: FormGroup;
  loading = false;
  showAlert = false;
  date = new Date();

  constructor(
    public dialogRef: MatDialogRef<MonedasComponent>,
    private fb: FormBuilder,
    public alert: AlertNoticeService,
    private currencyService: CurrencyService
  ) {
  }

  ngOnInit(): void {
    this.newCurrencyForm = this.fb.group({
      country: [, Validators.required],
      currency: [, Validators.required],
      symbol: [, Validators.required],
      abbreviation: [, Validators.required],
      iva: [, Validators.required]
    })
  }

  onNoClick(refresh): void {
    this.dialogRef.close(refresh);
  }

  get f() {
    return this.newCurrencyForm.controls;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.newCurrencyForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  submit(form) {
    this.loading = true;
    this.showAlert = false;
    if (form.valid) {
      const data = {
        id: null,
        name: form.value.currency,
        country: form.value.country,
        symbol: form.value.symbol,
        divisa: form.value.abbreviation,
        iva: form.value.iva
      }
        this.currencyService.createCurrency(data).subscribe(_res => {
            this.alert.setNotice('Moneda creada correctamente', 'success');
            this.showAlert = true;
            this.loading = false;
          setTimeout(() => this.onNoClick(true), 1000);
        }, _err => {
          this.alert.setNotice('No se pudo crear la moneda', 'danger');
          this.showAlert = true;
          this.loading = false;
        })
    } else {
      this.loading = false;
    }
  }

}
